<div class="w-72 lg:w-80 p-4">
  <!-- User Header -->
  <div class="flex items-center space-x-3 mb-4">
    <p-avatar
      [image]="currentUser()?.picture"
      [label]="
        currentUser()?.picture ? null : currentUser()?.username?.charAt(0)?.toUpperCase() || 'U'
      "
      size="large"
      class="w-full h-full"
      shape="circle"
      [style]="{ color: '#fff', backgroundColor: '#6366f1' }"
    >
    </p-avatar>
    <div class="flex-1">
      <h3 class="font-semibold text-neutral-900 dark:text-neutral-200 text-lg">
        {{ currentUser()?.full_name || currentUser()?.username || ('header.user.userLabel' | transloco) }}
      </h3>
      <p class="text-sm text-neutral-600 dark:text-neutral-400">
        {{ currentUser()?.email || ('header.user.noEmail' | transloco) }}
      </p>
    </div>
  </div>

  <!-- User Balance -->
  <div
    class="bg-gradient-to-r from-primary-300/20 to-primary-300/20 dark:from-primary-900/20 dark:to-primary-800/20 rounded-lg p-3 mb-4"
  >
    <div class="flex items-center justify-between">
      <span class="text-sm font-medium text-primary-700 dark:text-primary-300">{{
        'header.user.balance' | transloco
      }}</span>
      <span
        class="text-lg font-bold text-primary-600 dark:text-primary-400 flex items-center justify-between"
      >
        @if (balanceLoading()) {
          <span class="text-xs text-neutral-800 dark:text-neutral-100">{{
            'header.user.loading' | transloco
          }}</span>
        } @else {
          {{ getCurrentUserBalance()}} $
        }
      </span>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="space-y-2">
    <button
      (click)="goToProfile()"
      class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
    >
      <i class="pi pi-user text-neutral-900 dark:text-neutral-400 w-4 h-4"></i>
      <span class="text-neutral-700 dark:text-neutral-300">{{
        'header.user.profile' | transloco
      }}</span>
    </button>

    <button
      (click)="goToBalanceHistory()"
      class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
    >
      <i class="pi pi-wallet text-neutral-900 dark:text-neutral-400 w-4 h-4"></i>
      <span class="text-neutral-700 dark:text-neutral-300">{{
        'header.user.balanceHistory' | transloco
      }}</span>
    </button>

    <button
      (click)="goToHelpCenter()"
      class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
    >
      <i class="pi pi-question-circle text-neutral-900 dark:text-neutral-400 w-4 h-4"></i>
      <span class="text-neutral-700 dark:text-neutral-300">{{
        'header.user.helpCenter' | transloco
      }}</span>
    </button>

    <button
      (click)="goToSettings()"
      class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
    >
      <i class="pi pi-cog text-neutral-900 dark:text-neutral-400 w-4 h-4"></i>
      <span class="text-neutral-700 dark:text-neutral-300">{{
        'header.user.settings' | transloco
      }}</span>
    </button>

    @if ((!ldapEnabled)) {
      <button
        (click)="goToChangePassword()"
        class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
      >
        <i class="pi pi-key text-neutral-900 dark:text-neutral-400 w-4 h-4"></i>
        <span class="text-neutral-700 dark:text-neutral-300">{{
          'header.user.changePassword' | transloco
        }}</span>
      </button>
    }

    <!-- Language Selection -->
    <div class="w-full">
      <button
        #langTrigger
        type="button"
        class="w-full flex items-center justify-between px-3 py-2 rounded-lg transition-colors"
        [ngClass]="isDark() ? 'bg-neutral-700 hover:bg-neutral-600 text-neutral-200' : 'bg-neutral-100 hover:bg-neutral-200 text-neutral-800'"
        (click)="langPopover.toggle($event)"
      >
        <span class="flex items-center space-x-2">
          @if (currentLanguage()?.countryCode) {
            <img
              [src]="'https://flagcdn.com/16x12/' + currentLanguage()!.countryCode.toLowerCase() + '.png'"
              [alt]="currentLanguage()?.countryCode"
              width="16"
              height="12"
              class="rounded-sm"
            />
          }
          <span class="text-sm">{{ currentLanguage()?.nativeName || ('header.language' | transloco) }}</span>
        </span>
        <i class="pi pi-angle-down text-xs opacity-70"></i>
      </button>

      <p-popover #langPopover appendTo="body" styleClass="topbar-lang-popover">
        <div class="min-w-56 p-1">
          <div class="max-h-64 overflow-auto">
            @for (option of availableLanguages(); track option.code) {
              <button
                type="button"
                class="w-full flex items-center space-x-3 px-3 py-2 rounded-md text-start hover:bg-neutral-200 dark:hover:bg-neutral-700/50"
                [ngClass]="option?.code === currentLanguage()?.code ? (isDark() ? 'bg-neutral-700/60' : 'bg-neutral-200') : ''"
                (click)="selectLanguage(option); langPopover.hide()"
              >
                @if (!!option.countryCode) {
                  <img
                    [src]="'https://flagcdn.com/20x15/' + option.countryCode.toLowerCase() + '.png'"
                    [alt]="option.countryCode"
                    width="20"
                    height="15"
                    class="rounded-sm"
                  />
                }
                <div class="flex-1">
                  <div class="font-medium text-sm">{{ option.nativeName }}</div>
                  <div class="text-xs text-neutral-500 dark:text-neutral-400">
                    {{ option.name }}
                  </div>
                </div>
                @if (option?.code === currentLanguage()?.code) {
                  <i class="pi pi-check text-primary-500 text-xs"></i>
                }
              </button>
            }
          </div>
        </div>
      </p-popover>
    </div>

    <div class="border-t border-neutral-300 dark:border-neutral-700 my-2"></div>

    <button
      (click)="logout()"
      class="w-full flex items-center space-x-3 p-2 rounded-lg text-start hover:bg-red-300/40 dark:hover:bg-red-900/20 transition-colors text-red-400 dark:text-red-400"
    >
      <i class="pi pi-sign-out text-red-500 dark:text-red-400 w-4 h-4"></i>
      <span>{{ 'header.user.logout' | transloco }}</span>
    </button>

    <!-- App Version Info -->
    <div class="px-2 py-1 text-center">
      <span class="font-mono text-neutral-400/80 text-xs dark:text-neutral-700 px-2 py-1 rounded"
        >{{ 'header.user.version' | transloco }} {{ appVersion() }}</span
      >
    </div>
  </div>
</div>

